import L from 'leaflet';

// Подпись Leaflet по умолчанию идет с флагом перед названием — оставляем только ссылку
const LEAFLET_PREFIX = '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>';

// Карта Leaflet с тайлами OpenStreetMap. Политика OSM: адрес без поддоменов
// и обязательная атрибуция. prefix: false — без ссылки на Leaflet (мини-карта)
export const createOsmMap = (node, { prefix = LEAFLET_PREFIX, ...options } = {}) => {
  const map = L.map(node, { attributionControl: false, ...options });
  L.control.attribution({ prefix }).addTo(map);
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  }).addTo(map);
  return map;
};

// Leaflet меряет контейнер один раз при создании: если сетка или колонка потом
// поменяли ширину, тайлы догружаются только на старый размер. Следим сами
export const keepMapSized = (map, node, bounds, padding) => {
  if (typeof ResizeObserver === 'undefined') return () => {};
  let width = node.clientWidth;
  let height = node.clientHeight;
  const observer = new ResizeObserver(() => {
    if (node.clientWidth === width && node.clientHeight === height) return;
    width = node.clientWidth;
    height = node.clientHeight;
    map.invalidateSize();
    if (bounds) map.fitBounds(bounds, { padding });
  });
  observer.observe(node);
  return () => observer.disconnect();
};
